module.exports = __webpack_public_path__ + "img/product_91.d58e6f9.webp";